"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SECTION_LIST = void 0;
exports.SECTION_LIST = [
    'wallet',
    'feed',
    'followers',
    'following',
    'points',
    'communities',
    'posts',
    'blog',
    'comments',
    'replies',
    'settings',
    'engine',
    'permissions',
    'referrals',
    'payout',
    'activities',
    'spk',
    'trail'
];
//# sourceMappingURL=section-list.const.js.map